import { BACKEND_ENDPOINTS } from "Theconstants";
import { clearError, startAction } from "context/userSlice";
import { axiosPOSTLogin } from "./axios";
import { errorHandler } from "./errorHandler";
import { AppDispatch } from "context/store";

export const marcasAPI = {
  getMarcas: async function (
    dispatch: AppDispatch,
    setMarcas: React.Dispatch<React.SetStateAction<IMarcas["marcas"]>>
  ) {
    dispatch(startAction());
    try {
      const { data } = await axiosPOSTLogin.get<IMarcas>(
        BACKEND_ENDPOINTS.MARCAS
      );
      dispatch(clearError());
      setMarcas(data.marcas.sort());
    } catch (error) {
      errorHandler(error, dispatch, "GET MARCAS");
    }
  },
  createMarcas: async function (
    dispatch: AppDispatch,
    marcasArray: IMarcas["marcas"]
  ) {
    dispatch(startAction());
    try {
      const { data } = await axiosPOSTLogin.post<IMarcas>(
        BACKEND_ENDPOINTS.MARCAS,
        {
          marcas: marcasArray,
        }
      );
      dispatch(clearError());
      return data.marcas.sort();
    } catch (error) {
      errorHandler(error, dispatch, "CREATE MARCAS");
      return Promise.reject();
    }
  },
  deleteMarcas: async function (
    dispatch: AppDispatch,
    marcasArrayToDelete: IMarcas["marcas"]
  ) {
    dispatch(startAction());
    try {
      if (!marcasArrayToDelete.length) {
        throw Error("Seleccioná al menos una marca para borrar.");
      }
      const { data } = await axiosPOSTLogin.delete<IMarcas>(
        BACKEND_ENDPOINTS.MARCAS,
        {
          data: { marcas: marcasArrayToDelete },
        }
      );
      dispatch(clearError());
      return data.marcas.sort();
    } catch (error) {
      errorHandler(error, dispatch, "DELETE MARCAS");
      return Promise.reject();
    }
  },
};
